import { computed, action, observable } from 'mobx';
import { ProductSelectedUseCase } from '../use-cases/ProductSelectedUseCase';
import { ProductBaseController } from './ProductBaseController';
import { Product } from '../domain/entities/Product';
import { IFreeShippingAndReturnConfig } from '../interfaces/ITranslations';
import { ComponentTypes } from '../constants/ComponentTypes';
import { IProductQuickviewConfig } from '../interfaces/IProductQuickview';

export class ProductQuickViewController extends ProductBaseController {
    @observable public isClickable: boolean = true;
    @observable public showOverlay: boolean = true;
    @observable public selectedRating: number = -1;
    @observable public isLoaded: boolean = false;
    @observable public positionIndex: number = -1;
    protected config: IProductQuickviewConfig;

    public initialize = (config: IProductQuickviewConfig) => {
        this.config = config;
    };

    @computed
    public get freeShippingAndReturnConfig() {
        const { overrides, ...freeShippingAndReturnConfig } = this.config
            .freeShippingAndReturn as IFreeShippingAndReturnConfig;

        const configOverrides = overrides && overrides[ComponentTypes.PRODUCT_QUICKSHOP];

        return { ...freeShippingAndReturnConfig, ...configOverrides };
    }

    @action
    public showQuickView = (product: Product, skuId: string) => {
        this.product = product;
        this.selectedSkuId = skuId;
        this.isLoaded = true;
    };

    @computed
    get data() {
        const {
            product,
            selectedSku,
            productQuickViewImageCarouselSettings,
            productQuickViewThumbnailsCarouselSettings,
            isImageCarouselDisabled,
            isThumbnailsCarouselEnabled
        } = this;

        return {
            product: product,
            defaultSku: this.defaultSku,
            defaultSize: this.defaultSize,
            sizes: product.sizes,
            shades: product.shades,
            quantity: product.quantity,
            autoReplenishOptions: [],
            selectedAutoReplenishOption: this.selectedAutoReplenishOption,
            isAutoReplenishSelected: this.isAutoReplenishSelected,
            isLoaded: this.isLoaded,
            productUrl: this.selectedProductUrl,
            selectedSku,
            productQuickViewImageCarouselSettings,
            productQuickViewThumbnailsCarouselSettings,
            isImageCarouselDisabled,
            isThumbnailsCarouselEnabled,
            freeShippingAndReturnConfig: this.freeShippingAndReturnConfig
        };
    }

    public productUpdateQuantity = (quantity: number) => {
        this.product.setQuantity(quantity);
    };

    @computed
    get defaultSku() {
        return this.product.defaultSku;
    }

    @computed
    get defaultSize() {
        return this.product.defaultSize;
    }

    @computed
    private get productQuickViewImageCarouselSettings() {
        return this.imageCarouselSettings && this.imageCarouselSettings.productQuickshop;
    }

    @computed
    private get productQuickViewThumbnailsCarouselSettings() {
        return (
            this.productQuickViewImageCarouselSettings &&
            this.productQuickViewImageCarouselSettings.thumbnailsCarouselSettings
        );
    }

    @computed
    private get isImageCarouselDisabled() {
        return (
            this.productQuickViewImageCarouselSettings &&
            this.productQuickViewImageCarouselSettings.enabled === false
        );
    }

    @computed
    private get isThumbnailsCarouselEnabled() {
        return (
            this.productQuickViewImageCarouselSettings &&
            this.productQuickViewImageCarouselSettings.showThumbnails
        );
    }

    // @todo ADD EVENT EMITER TO THE ECOMAPP TO CHANGE ROUTE
    public goToSPP = async (positionIndex: number) => {
        const navigateToProductUseCase = new ProductSelectedUseCase(
            this.data.productUrl || '',
            this.selectedSkuId,
            positionIndex
        );
        await navigateToProductUseCase.execute();
    };

    @action
    public onSelectRating = (index: number) => {
        if (this.isClickable) {
            this.selectedRating = index;
            this.isClickable = false;
        }
    };

    @action
    public disableEdit = () => {
        this.isClickable = false;
    };

    @action
    public toggleOverlay = () => {
        if (this.isClickable) {
            this.showOverlay = !this.showOverlay;
        }
    };

    @action
    public onReadReviewsClick = () => {
        return;
    };
}
